// Формат времени зависит от языка интерфейса: EN — 12-часовой с AM/PM (2:05 PM),
// остальные языки — привычный 24-часовой (14:05). Дату каждый компонент собирает по-своему,
// здесь только часы и минуты и числовая дата

const pad = (value) => String(value).padStart(2, '0');

export function formatClockTime(hours, minutes, language) {
  const mm = pad(minutes);

  if (language !== 'en') return `${pad(hours)}:${mm}`;

  // В en-US часы пишутся без ведущего нуля, полночь и полдень — как 12
  const suffix = hours < 12 ? 'AM' : 'PM';
  const hours12 = hours % 12 === 0 ? 12 : hours % 12;

  return `${hours12}:${mm} ${suffix}`;
}

// Время из объекта Date в часовом поясе браузера
export function formatTimeFromDate(date, language) {
  return formatClockTime(date.getHours(), date.getMinutes(), language);
}

// Время, уже посчитанное как строка "HH:MM" (например, расписание RMC)
export function formatClockString(timeStr, language) {
  const [hours, minutes] = String(timeStr).split(':').map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return timeStr;

  return formatClockTime(hours, minutes, language);
}

// Дата цифрами в привычном для языка виде: 15.09.2026 (RU, DE, CS), 15/09/2026 (IT, ES, FR)
// и 2026-09-15 (EN)
export function formatNumericDate(date, language) {
  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  if (language === 'ru' || language === 'de' || language === 'cs') return `${day}.${month}.${year}`;
  if (language === 'it' || language === 'es' || language === 'fr') return `${day}/${month}/${year}`;
  return `${year}-${month}-${day}`;
}

// Локаль для Intl/toLocaleString — там 12-часовой формат включается сам.
// Английская локаль местами нужна en-GB (день перед месяцем) — ее задает вызывающий
export function localeFor(language, englishLocale = 'en-US') {
  if (language === 'ru') return 'ru-RU';
  if (language === 'it') return 'it-IT';
  if (language === 'de') return 'de-DE';
  if (language === 'es') return 'es-ES';
  if (language === 'fr') return 'fr-FR';
  if (language === 'cs') return 'cs-CZ';
  return englishLocale;
}
